module.exports = __webpack_public_path__ + "static/media/product_header_bg.ad39ab64.jfif";